module.exports = __webpack_public_path__ + "static/img/l16.87ef08e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/l16.png
// module id = uw4C
// module chunks = 0